import AccessTokenStore from '../accessTokenStore'

const HEADER_NAME = 'Authorization'


/**
 * Request interceptor: attach the access token to each request, when one is
 * held.
 *
 * Truthiness rather than a null check, so a token that arrived empty is
 * treated as no token at all instead of producing a credential-less
 * `Bearer ` header.
 *
 * @param {Object} request
 *
 * @returns {Object} request
 */
export default function bearerInterceptor(request) {
  const accessToken = AccessTokenStore.getAccessToken()

  if ( !accessToken ) {
    return request
  }

  return {
    ...request,
    headers: {
      ...request.headers,
      [HEADER_NAME]: `Bearer ${ accessToken }`,
    },
  }
}
